import { render } from "./ResponseNamePage.vue?vue&type=template&id=7997405e"
import script from "./ResponseNamePage.vue?vue&type=script&lang=js"
export * from "./ResponseNamePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__